/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Patient routes
 */

// Pages
import AppointmentsManagement from '@nephro/pages/MyAppointments/AppointmentsManagement';
import AppointmentsCalendar from '@nephro/pages/MyAppointments/AppointmentsCalendar';
import AppointmentsSchedule from '@nephro/pages/MyAppointments/AppointmentsSchedule';

const pathStart = '/main/appointments';
const routes = [
  {
    path: `${pathStart}`,
    isProtected: true,
    component: AppointmentsManagement,
    exact: true
  },
  {
    path: `${pathStart}/calendar`,
    isProtected: true,
    component: AppointmentsCalendar,
    exact: true
  },
  {
    path: `${pathStart}/schedule`,
    isProtected: true,
    component: AppointmentsSchedule,
    exact: true
  },
  {
    path: `${pathStart}/reschedule-appointment`,
    isProtected: true,
    component: AppointmentsSchedule,
    exact: true
  },
  { redirect: true, to: `${pathStart}` }
];

export default routes;
